import {DirectiveOptions} from 'vue';

// 더블클릭 방지 1초에 한번만 누르게
const notDoubleClick: DirectiveOptions = {
  bind(el: HTMLElement): void {
    el.addEventListener('click', (): void => {
      (el as HTMLInputElement).disabled = true;
      setTimeout((): void => {
        (el as HTMLInputElement).disabled = false;
      }, 1000);
    });
  }
};
export default notDoubleClick;
